/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[_ngcontent-%COMP%]{width: 100%; margin-bottom:  5px;}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvZHluYW1pYy1mb3JtL2NvbXBvbmVudHMvZm9ybS1jcHIvZm9ybS1jcHIuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFdBQVcsRUFBRSxtQkFBbUIsQ0FBQyIsImZpbGUiOiJzcmMvYXBwL2R5bmFtaWMtZm9ybS9jb21wb25lbnRzL2Zvcm0tY3ByL2Zvcm0tY3ByLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJpbnB1dHt3aWR0aDogMTAwJTsgbWFyZ2luLWJvdHRvbTogIDVweDt9XHJcbiJdfQ== */"];
export { styles as styles };
